export default __webpack_public_path__ + "static/hahn-3b8b196160098679735dc7edffba4cf6.jpg";